export const SET_PLAN = 'SET_PLAN';

export function setPlanInfo(payload) {
  return { type: SET_PLAN, payload };
}
